export enum LearningTemplateTypes {
  LEARNING_PLAN = 'planning',
  LEARNING_STORY = 'stories',
  LEARNING_TABLE = 'tables',
}
